module.exports = __webpack_public_path__ + "static/media/samsung-aife-2020-performance.90ca1bf6.mp4";